import { useEffect, useState } from "react";

const LessMoreTextFieldComp = ({ label = '', required= '', value = '',maxLength=255,rows=3 }) => {
    const [isExpand, setExpanded] = useState(false);
    const formattedValue = Array.isArray(value) ? value.join(', ') : value || '';
    const isExpandFun = (val) => {
        setExpanded(!val);
    }
    return (
        <div className='mui-outlined-view' style={{ cursor: 'not-allowed' }}>
            <fieldset className="mui-fieldset text-container" style={{ minHeight: 23 + rows * 15 }}>
                <legend>{label}{required === true ? '*' : ''}</legend>
                    {formattedValue?.length > maxLength ? !isExpand ?
                        <>
                            {formattedValue.substring(0, maxLength)}<span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); isExpandFun(isExpand); }}>...more</span>
                        </>
                        : <>
                            {formattedValue} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); isExpandFun(isExpand); }}>...less</span>
                        </>
                        : <span>{formattedValue}</span>}
            </fieldset>
        </div>
    )
}
export default LessMoreTextFieldComp;